<template>
<!-- 文件汇总弹窗 -->
	<Modal
		width="640"
		:value="showModal"
		title="文件汇总"
		@on-visible-change="visibleChange">
		<div class="biddingFile">
			<span>邀请函/招标公告附件：</span>
			<Input readonly style="width: 300px" v-model="type11[type11.length-1].displayName" placeholder="--未上传相关文件--"></Input>
			<Upload ref="upload" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
				<Button :disabled="editPermission ? false : !((form.project_status === '未发起' || form.project_status === '立项审核退回') && form.principal === user.name)" type="primary" size="small" @click="fileType=11">上传</Button>
			</Upload>
			<Button :disabled="editPermission ? false : type11.length === 1 || !((form.project_status === '未发起' || form.project_status === '立项审核退回') && form.principal === user.name)" size="small" type="error" @click="delectFile('邀请函/招标公告附件',type11)">删除</Button>
			<Button :disabled="type11.length === 1" size="small" type="primary" @click="downLoad(type11[type11.length-1])">下载</Button>
		</div>
		<div class="biddingFile" style="border-top: 1px dashed #ccc">
			<span>报名资料：</span>
			<Input readonly style="width: 300px" v-model="type7[type7.length-1].displayName" placeholder="--未上传相关文件--"></Input>
			<Upload ref="upload" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
				<Button :disabled="editPermission ? false : !(form.project_status === '等待上传报名资料' && form.principal === user.name)" type="primary" size="small" @click="fileType=7">上传</Button>
			</Upload>
			<Button :disabled="editPermission ? false : type7.length === 1 || !(form.project_status === '等待上传报名资料' && form.principal === user.name)" size="small" type="error" @click="delectFile('报名资料',type7)">删除</Button>
			<Button :disabled="type7.length === 1" size="small" type="primary" @click="downLoad(type7[type7.length-1])">下载</Button>
		</div>
		<div class="biddingFile" style="border-top: 1px dashed #ccc">
			<span>招标文件：</span>
			<Input readonly style="width: 300px" v-model="type1[type1.length-1].displayName" placeholder="--未上传相关文件--"></Input>
			<Upload ref="upload" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
				<Button :disabled="editPermission ? false : !(form.project_status === '等待上传投标文件' && form.principal === user.name)" type="primary" size="small" @click="fileType=1">上传</Button>
			</Upload>
			<Button :disabled="editPermission ? false : type1.length === 1 || !(form.project_status === '等待上传投标文件' && form.principal === user.name)" size="small" type="error" @click="delectFile('招标文件',type1)">删除</Button>
			<Button :disabled="type1.length === 1" size="small" type="primary" @click="downLoad(type1[type1.length-1])">下载</Button>
		</div>
		<div class="biddingFile" style="padding-top: 0">
			<span>投标文件初稿：</span>
			<Input readonly style="width: 300px" v-model="type2[type2.length-1].displayName" placeholder="--未上传相关文件--"></Input>
			<Upload ref="upload" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
				<Button :disabled="editPermission ? false : !(form.project_status === '等待上传投标文件' && form.participation === '是' && form.principal === user.name)" type="primary" size="small" @click="fileType=2">上传</Button>
			</Upload>
			<Button :disabled="editPermission ? false : type2.length === 1 || !(form.project_status === '等待上传投标文件' && form.participation === '是' && form.principal === user.name)" size="small" type="error" @click="delectFile('投标文件初稿',type2)">删除</Button>
			<Button :disabled="type2.length === 1" size="small" type="primary" @click="downLoad(type2[type2.length-1])">下载</Button>
		</div>
		<div class="biddingFile" style="border-top: 1px dashed #ccc">
			<span>审核反馈意见：</span>
			<Input readonly style="width: 300px" v-model="type4[type4.length-1].displayName" placeholder="--未上传相关文件--"></Input>
			<Upload ref="upload" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
				<Button :disabled="editPermission ? false : !(form.project_status === '文件审核中' && form.reviewPerson === user.name)" type="primary" size="small" @click="fileType=4">上传</Button>
			</Upload>
			<Button :disabled="editPermission ? false : type4.length === 1 || !(form.project_status === '文件审核中' && form.reviewPerson === user.name)" size="small" type="error" @click="delectFile('审核反馈意见',type4)">删除</Button>
			<Button :disabled="type4.length === 1" size="small" type="primary" @click="downLoad(type4[type4.length-1])">下载</Button>
		</div>
		<div class="biddingFile" style="border-top: 1px dashed #ccc">
			<span>投标文件终稿：</span>
			<Input readonly style="width: 300px" v-model="type3[type3.length-1].displayName" placeholder="--未上传相关文件--"></Input>
			<Upload ref="upload" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
				<Button :disabled="editPermission ? false : !(form.project_status === '等待上传投标文件终稿' && form.principal === user.name)" type="primary" size="small" @click="fileType=3">上传</Button>
			</Upload>
			<Button :disabled="editPermission ? false : type3.length === 1 || !(form.project_status === '等待上传投标文件终稿' && form.principal === user.name)" size="small" type="error" @click="delectFile('投标文件终稿',type3)">删除</Button>
			<Button :disabled="type3.length === 1" size="small" type="primary" @click="downLoad(type3[type3.length-1])">下载</Button>
		</div>
		<div class="biddingFile">
			<span>盖章/签字要求：</span>
			<Input readonly style="width: 300px" v-model="type6[type6.length-1].displayName" placeholder="--未上传相关文件--"></Input>
			<Upload ref="upload" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
				<Button :disabled="editPermission ? false : !(form.project_status === '等待上传投标文件终稿' && form.principal === user.name)" type="primary" size="small" @click="fileType=6">上传</Button>
			</Upload>
			<Button :disabled="editPermission ? false : type6.length === 1 || !(form.project_status === '等待上传投标文件终稿' && form.principal === user.name)" size="small" type="error" @click="delectFile('盖章/签字要求',type6)">删除</Button>
			<Button :disabled="type6.length === 1" size="small" type="primary" @click="downLoad(type6[type6.length-1])">下载</Button>
		</div>
		<div class="biddingFile" style="border-top: 1px dashed #ccc">
			<span>中标通知书/框架协议：</span>
			<Input readonly style="width: 300px" v-model="type5[type5.length-1].displayName" placeholder="--未上传相关文件--"></Input>
			<Upload ref="upload" :data="uploadFileInit.extradata" :action="uploadFileInit.action" :before-upload="handleBeforeUpload" :show-upload-list="false">
				<Button :disabled="editPermission ? false : !(form.project_status === '待结项' && form.principal === user.name)" type="primary" size="small" @click="fileType=5">上传</Button>
			</Upload>
			<Button :disabled="editPermission ? false : type5.length === 1 || !(form.project_status === '待结项' && form.principal === user.name)" size="small" type="error" @click="delectFile('中标通知书/框架协议',type5)">删除</Button>
			<Button :disabled="type5.length === 1" size="small" type="primary" @click="downLoad(type5[type5.length-1])">下载</Button>
		</div>
		<div slot="footer"></div>
	</Modal>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import axios from 'axios'
import { fileUtil } from '@/lib/abpfile'
import { setTimeout } from 'timers'
import { formatDate } from "@/lib/tool"

export default {
	props: {
		showModal: Boolean,
		formData: Object
	},
	data() {
		return {
			form: {},
			file: '',
			fileType: '',
			bucket: 'clneiwang',
      dir: 'toubiaoManage/',
			uploadFileInit: {
        action: '',
        extradata: {}
			},
			projectId: 0,
			type11: [{displayName: ''}],
			type1: [{displayName: ''}],
			type2: [{displayName: ''}],
			type3: [{displayName: ''}],
			type4: [{displayName: ''}],
			type5: [{displayName: ''}],
			type6: [{displayName: ''}],
			type7: [{displayName: ''}],
		}
	},
	computed: {
		user() {
      return this.$store.state.session.user
		},
		editPermission() {
      // 获取用户角色信息
      return this.$store.getters["session/hasRoles"]("战略中心")
    }
	},
  watch: {
    formData(val) {
      this.form = val
      this.dataFormat()
    }
  },
	methods: {
		dataFormat() {
      Object.keys(this.form).forEach(key => {
        if (this.form[key] !== '' && this.form[key] !== null) {
          switch(key) {
            case 'bond':
            case 'budget':
            case 'bid_budget':
            case 'buyer_contact':
            case 'my_offer':
            case 'marginAccount':
              this.form[key] = this.form[key].toString()
            break
            case 'property':
            if (typeof this.form[key] === 'string') {
              this.form[key] = this.form[key].split('+')
            }
          }
        } else {
          if (key === 'property') {
            this.form[key] = []
          }
        }
      })
    },
		visibleChange(status) {
      this.$emit('visibleChange',status)
		},
		// 获取历史文件
		async getHistory(id) {
			this.projectId = id
			this.file = []
			this.type11 = [{displayName: ''}]
			this.type1 = [{displayName: ''}]
			this.type2 = [{displayName: ''}]
			this.type3 = [{displayName: ''}]
			this.type4 = [{displayName: ''}]
			this.type5 = [{displayName: ''}]
			this.type6 = [{displayName: ''}]
			this.type7 = [{displayName: ''}]
      // 获取历史上传文件
      let rep = await ajax.get(requestUrls.AbpAliOss.GetListByObjectId,{
        params: {
          objectId: id,
          objectIdType: 'BidManage'
        }
			})
			rep.data.result.items.forEach(file => {
				// 后台返回type为字符串类型
				this[`type${file.fileType}`].push(file)
			})
			return rep.data.result.items
			// .then(res => {
      //   let rep = res.data.result.items
      //   rep.forEach(file => {
			// 		// 后台返回type为字符串类型
			// 		this[`type${file.fileType}`].push(file)
      //   })
      // })
		},
		// 选择文件
    handleBeforeUpload(file) {
			// 初始化文件上传
      fileUtil.downloadInit(this.user.id,this.fileType,this.bucket,this.dir).then(val => {
        this.uploadFileInit = val
      })
      this.file = file
			this.$set(this.file, 'displayName', file.name)
			setTimeout(() => {
				this.upLoad()
			},500)
      return false
    },
    // 上传文件
    async upLoad() {
			let suffix = fileUtil.get_suffix(this.file.name)
			this.uploadFileInit.extradata.key = this.uploadFileInit.extradata.key + fileUtil.random_string(10) + suffix
			this.uploadFileInit.extradata['x:displayname'] = this.file.name
			this.uploadFileInit.extradata['x:objectid'] = this.projectId
			this.uploadFileInit.extradata['x:objectidtype'] = 'BidManage'
			this.$Spin.show()
			try {
				let uploadData = new FormData()
				for (let key in this.uploadFileInit.extradata) {
					uploadData.append(key, this.uploadFileInit.extradata[key])
				}
				uploadData.append('file', this.file)
				let rep = await axios.post(this.uploadFileInit.action, uploadData)
				this.$Spin.hide()
				if (rep.data.success) {
					this.$Message.success(`${this.file.displayName}上传成功`)
          this.file = ''
          this.fileType = ''
				} else {
					this.$Message.error(`${this.file.displayName}上传失败`)
				}
			} catch (err) {
				console.error(err)
				this.$Spin.hide()
				this.$Message.error(`${this.file.displayName}上传失败`)
			}
			this.getHistory(this.projectId)
			return
    },
    // 删除文件
    delectFile(title,files) {
      this.$Modal.confirm({
        title: '文件删除',
        okText: '删除',
        cancelText: '取消',
        content: `确定要删除${title}吗?`,
        onOk: () => {
          for( let i = 1; i < files.length; i++) {
            ajax.delete(requestUrls.AbpAliOss.Delete, {
              params: {
                id: files[i].id
              }
            }).then(() => {
							this.getHistory(this.projectId)
              this.$Message.success('删除成功')
            })
          }
        },
        onCancel: () => {}
      })
		},
		// 下载文件
		downLoad(file) {
			ajax.get(requestUrls.AbpAliOss.GetDownUrl,{
				params: {
					id: file.id
				}
			}).then(res => {
				window.open(res.data.result)
			})
    },
	}
};
</script>
<style lang="less" scoped>
/deep/.ivu-modal-body {
	padding: 0;
}
.ivu-upload {
  display: inline-block;
}
.biddingFile {
  padding: 16px 10px;
  >span {
    display: inline-block;
		width: 140px;
		text-align: right;
  }
  button {
    margin-left: 10px;
	}
}
</style>
